import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AboutUs from './pages/AboutUs/AboutUs';
import Products from './pages/Products/Products';
import Applications from './pages/Applications/Applications';
import ContactPage from './pages/ContactUs/ContactUs';
import Services from './pages/Services/Services';
import { Login } from './pages/Login/Login';
import { Home } from './pages/Home/Home';
import DetailPage from './pages/DetailPage/DetailPage';
import GetQuote from './pages/GetQuote/GetQuote';
import { Dashboard } from './pages/Dashboard/Dashboard';
import { Analytics } from './pages/Dashboard/Analytics/Analytics';
import { ContactEnq } from './pages/Dashboard/ContactEnq/ContactEnq';
import { ProductEnq } from './pages/Dashboard/ProductEnq/ProductEnq';
import { ServiceEnq } from './pages/Dashboard/ServiceEnq/ServiceEnq';
import { ProtectedRoute } from './pages/Login/ProtectedRoute';
import { ForgotPassword } from './pages/Login/ForgotPassword';

export const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/products" element={<Products />} />
            <Route path="/applications" element={<Applications />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/quote" element={<GetQuote />} />
            <Route path="/detail-page" element={<DetailPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/dashboard" element={
                <ProtectedRoute>
                    <Dashboard />
                </ProtectedRoute>
            }>
                <Route index element={<Analytics />} />
                <Route path="contact" element={<ContactEnq />} />
                <Route path="product" element={<ProductEnq />} />
                <Route path="service" element={<ServiceEnq />} />
            </Route>
        </Routes>
    );
};